import styled from 'styled-components';
import { Dropdown } from 'react-bootstrap';
import { COLORS } from 'modules/core/theme/colors';

import { CreditScoreColors } from '../enums/creditScoreColors.enum';
import { CreditScoreColor } from '../types';

const { Toggle, Menu, Item } = Dropdown;

const OVERRIDER_DROPDOWN_SELECTORS = `
  &,
  &:hover,
  &:focus,
  &.btn-primary:not(:disabled):not(.disabled):active,
  .show > &.btn-primary.dropdown-toggle
`;

const MAP_OPTION_BACKGROUND_BY_SCORE = new Map([
  [CreditScoreColors.GREEN, COLORS.GREEN_10],
  [CreditScoreColors.TEAL, COLORS.GREEN_11],
  [CreditScoreColors.BLUE, COLORS.BLUE_15],
  [CreditScoreColors.DARK_BLUE, COLORS.BLUE_16],
]);

const MAP_OPTION_HOVER_BACKGROUND_BY_SCORE = new Map([
  [CreditScoreColors.GREEN, COLORS.GREEN_12],
  [CreditScoreColors.TEAL, COLORS.GREEN_13],
  [CreditScoreColors.BLUE, COLORS.BLUE_17],
  [CreditScoreColors.DARK_BLUE, COLORS.BLUE_18],
]);

const MAP_OPTION_TEXT_AND_BORDER_COLOR_BY_SCORE = new Map([
  [CreditScoreColors.GREEN, COLORS.GREEN_8],
  [CreditScoreColors.TEAL, COLORS.GREEN_14],
  [CreditScoreColors.BLUE, COLORS.BLUE_11],
  [CreditScoreColors.DARK_BLUE, COLORS.BLUE_5],
]);

export const ScoreToggle = styled(Toggle)`
  width: 100%;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme: { fontSize } }) => fontSize.normal};
  transition: none;
`;

export const DefaultToggle = styled(ScoreToggle)<{ $isOpen: boolean }>`
  ${OVERRIDER_DROPDOWN_SELECTORS} {
    background-color: ${({ $isOpen }) => ($isOpen ? COLORS.WHITE : COLORS.GREEN_10)};
    border: 1px solid ${({ $isOpen }) => ($isOpen ? COLORS.GREEN_8 : COLORS.GREEN_8)};
    color: ${COLORS.GREEN_8};
    box-shadow: none;
    font-weight: 500;
  }

  &:disabled {
    color: ${COLORS.GREY_24};
    background-color: ${COLORS.GREY_31};
    opacity: 1;
    border: 1px solid ${COLORS.GREY_32};
  }

  &::after {
    color: ${({ $isOpen }) => ($isOpen ? COLORS.GREEN_8 : COLORS.GREEN_8)};
  }

  &:disabled::after {
    color: ${COLORS.GREY_32};
  }
`;

export const SelectedScoreToggle = styled(ScoreToggle)<{ color: CreditScoreColor }>`
  ${OVERRIDER_DROPDOWN_SELECTORS} {
    background-color: white;
    border: ${({ color }) => `1px solid ${MAP_OPTION_TEXT_AND_BORDER_COLOR_BY_SCORE.get(color)}`};
    color: ${({ color }) => MAP_OPTION_TEXT_AND_BORDER_COLOR_BY_SCORE.get(color)};
    box-shadow: none;
    font-weight: 500;
  }

  &:disabled {
    color: ${COLORS.GREY_24};
    background-color: ${COLORS.GREY_31};
    opacity: 1;
    border: 1px solid ${COLORS.GREY_32};
  }
`;

export const ScoreMenu = styled(Menu)`
  width: max-content;
  min-width: 100%;
  padding: 0;
  border: none;
`;

export const OptionItem = styled(Item)<{ color: CreditScoreColor; selected?: boolean }>`
  background-color: ${({ color, selected }) => (selected ? COLORS.WHITE : MAP_OPTION_BACKGROUND_BY_SCORE.get(color))};
  color: ${({ color }) => MAP_OPTION_TEXT_AND_BORDER_COLOR_BY_SCORE.get(color)};
  font-size: ${({ theme: { fontSize } }) => fontSize.normal};
  font-weight: 700;
  padding: 5px;
  position: relative;
  cursor: pointer;
  border: ${({ color }) => `1px solid ${MAP_OPTION_TEXT_AND_BORDER_COLOR_BY_SCORE.get(color)}`};
  display: flex;
  align-items: center;
  justify-content: center;

  &:not(:last-of-type) {
    border-bottom: none;
  }

  &:last-of-type {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  &:first-of-type {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  &:hover {
    background-color: ${({ color, selected }) =>
      selected ? COLORS.WHITE : MAP_OPTION_HOVER_BACKGROUND_BY_SCORE.get(color)};
    color: ${({ color }) => MAP_OPTION_TEXT_AND_BORDER_COLOR_BY_SCORE.get(color)};
    box-shadow: ${({ color }) => `inset 0 0 0 0.5px ${MAP_OPTION_TEXT_AND_BORDER_COLOR_BY_SCORE.get(color)}`};
  }
`;

export const OptionContent = styled.div`
  display: inline-block;
  position: relative;
  width: max-content;
`;

export const TextWrapper = styled.span`
  position: relative;
  display: grid;
  grid-template-columns: 12px auto 12px;
  align-items: center;
`;

export const CheckmarkIcon = styled.div<{ color: CreditScoreColor }>`
  position: relative;
  width: 10px;
  height: 8px;

  &::before {
    content: '';
    position: absolute;
    width: 5px;
    height: 10px;
    border: solid ${({ color }) => MAP_OPTION_TEXT_AND_BORDER_COLOR_BY_SCORE.get(color)};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    top: -3px;
  }
`;

export const CheckmarkSpacer = styled.div``;
